import { useImpersonationStore } from '../stores/impersonation.store';

/**
 * Combined hook for all impersonation functionality
 */
export function useImpersonation() {
  const impersonatedUser = useImpersonationStore((state) => state.impersonatedUser);
  const recentUsers = useImpersonationStore((state) => state.recentUsers);
  const setImpersonatedUser = useImpersonationStore((state) => state.setImpersonatedUser);
  const addRecentUser = useImpersonationStore((state) => state.addRecentUser);
  const removeRecentUser = useImpersonationStore((state) => state.removeRecentUser);
  const clearImpersonatedUser = useImpersonationStore((state) => state.clearImpersonatedUser);
  const clearAll = useImpersonationStore((state) => state.clearAll);

  return {
    impersonatedUser,
    recentUsers,
    setImpersonatedUser,
    addRecentUser,
    removeRecentUser,
    clearImpersonatedUser,
    clearAll,
  };
}
